import { Navigate } from "react-router-dom";
import AdminPage from "../admin";

function PrivateRoute({ component: component  ,setSidebarActive,sidebarActive}) {
    const token = window.localStorage.getItem('token')
    return token ? <AdminPage setSidebarActive={setSidebarActive} sidebarActive={sidebarActive}/> : <Navigate to='/login' />
}
export default PrivateRoute;